import React, { useState } from "react";

// --- Data Models ---
const HOROSCOPE_DATA = {
  daily: {
    general:
      "Capricorn is ruled by Saturn, the planet of discipline and responsibility, which makes them ambitious, hardworking, and highly focused on long-term goals. They are natural planners who value structure, tradition, and stability in life. On the emotional side, they may appear reserved or serious, but beneath that calm exterior lies a deeply loyal and protective heart. They take relationships seriously and believe in building lasting bonds based on trust.",
    love: "Capricorn is ruled by Saturn, the planet of discipline and responsibility, which makes them ambitious, hardworking, and highly focused on long-term goals. They are natural planners who value structure, tradition, and stability in life.",
    career:
      "Capricorn is ruled by Saturn, the planet of discipline and responsibility, which makes them ambitious, hardworking, and highly focused on long-term goals. They are natural planners who value structure, tradition, and stability in life. On the emotional side, they may appear reserved or serious, but beneath that calm exterior lies a deeply loyal and protective heart. They take relationships seriously and believe in building lasting bonds based on trust.",
    health:
      "Capricorn is ruled by Saturn, the planet of discipline and responsibility, which makes them ambitious, hardworking, and highly focused on long-term goals.",
  },
  weekly: {
    general: "Weekly forecast content goes here...",
    love: "Weekly love...",
    career: "Weekly career...",
    health: "Weekly health...",
  },
  monthly: {
    general: "Monthly forecast content goes here...",
    love: "Monthly love...",
    career: "Monthly career...",
    health: "Monthly health...",
  },
  yearly: {
    general: "Yearly forecast content goes here...",
    love: "Yearly love...",
    career: "Yearly career...",
    health: "Yearly health...",
  },
};

// --- Helper Components ---

// Component for a single section (Love, Career, Health)
const HoroscopeSection = ({ title, content }) => (
  <div className="mt-6">
    <h2 className="text-xl font-bold text-gray-900 mb-2">{title}</h2>
    <p className="text-gray-700 leading-relaxed text-base">{content}</p>
  </div>
);

// --- Main Component ---
function Horoscope() {
  const [activeTab, setActiveTab] = useState("daily");
  const currentHoroscope = HOROSCOPE_DATA[activeTab];

  const tabs = [
    { id: "daily", label: "Today" },
    { id: "weekly", label: "Weekly" },
    { id: "monthly", label: "Monthly" },
    { id: "yearly", label: "Yearly" },
  ];

  return (
    <section className="notifications-bg py-8 md:py-12 bg-white">
      <div className="container">
        {/* Header and Action Buttons */}
        <div className="flex justify-between items-center mb-6 md:mb-8">
          <h1 className="web-h3 text-gray-950">Horoscope</h1>
          <div className="flex space-x-3">
            <button className="custom-btn custom-btn-secondary">
              Save Report
            </button>
            <button className="custom-btn custom-btn-primary">
              Talk to Astrologer
            </button>
          </div>
        </div>

        {/* Main Content: Two Columns (Flexible on Mobile, Split on Desktop) */}
        <div className="flex flex-col lg:flex-row gap-6">
          {/* --- LEFT COLUMN: Horoscope Content & Tabs --- */}
          <div className="lg:w-3/4 bg-white p-[15px] md:p-[20px] rounded-[20px] border border-gray-100">
            {/* Tabs Navigation */}
            <div className="flex justify-between border-b border-gray-200 mb-6">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`
                   p-[10px] text-[14px] medium flex-1 transition-colors
                  ${
                    activeTab === tab.id
                      ? "text-[#020079] border-b-2 border-[#020079]"
                      : "text-gray-500 hover:text-gray-700"
                  }
                `}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {/* Tab Content */}
            <div className="horoscope-content">
              {/* General Description */}
              <p className="text-gray-700 leading-relaxed text-base mb-8">
                {currentHoroscope.general}
              </p>

              {/* Sub-Sections */}
              <HoroscopeSection title="Love" content={currentHoroscope.love} />
              <HoroscopeSection
                title="Career"
                content={currentHoroscope.career}
              />
              <HoroscopeSection
                title="Health"
                content={currentHoroscope.health}
              />
            </div>
          </div>

          {/* --- RIGHT COLUMN: Profile Card (Fixed Width) --- */}
          <div className="lg:w-1/4 flex-shrink-0">
            <div className="text-center bg-primary-50 p-[15px] md:p-[20px] rounded-[20px]">
              <div className="bg-white border border-gray-100 rounded-[10px] p-[10px] flex flex-col gap-[15px]">
                
                <div className="w-[71px] h-[71px] mx-auto rounded-full flex items-center justify-center">
                  <img
                    src="/images/user02.png"
                    alt="User"
                    className="w-full h-full object-cover rounded-full"
                  />
                </div>

                <div className="flex flex-col gap-[5px]">
                    <h3 className="web-h4 text-gray-950">Capricorn</h3>
                    <p className="body-md text-gray-950">10th Jan 1997</p>
                </div> 
              </div>



              {/* Lucky Details */}
              <div className="space-y-4 pt-4 border-t border-gray-100">
                <div className="flex items-center justify-between text-base flex-col gap-[2px]">
                  <span className="w-[16px] h-[16px] rounded-full bg-red-600"></span>
                  <span className="body-md text-gray-500">Lucky Color</span>
                </div>

                <div className="flex items-center justify-between text-base flex-col gap-[2px]">
                <span className="body-md text-gray-950">10</span>
                  <span className="body-md text-gray-500">Lucky Number</span>
                </div>

                <div className="flex items-center justify-between text-base flex-col gap-[2px]">
                  <span className="body-md text-gray-950">10:10 AM</span>
                  <span className="body-md text-gray-500">Lucky Time</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Horoscope;
